var utils = require("../../../utils/utils"),
	taskDnD = require("./tasks_dnd"),
	linkDnD = require("./links_dnd"),
	domHelpers = require("../../../utils/dom_helpers");

var initializer = (function(){
	return function(gantt){
		var services = gantt.$services;
		return {
			onCreated: function (timeline) {
				var config = timeline.$config;
				config.bind = utils.defined(config.bind) ? config.bind : "task";
				config.bindLinks = utils.defined(config.bindLinks) ? config.bindLinks : "link";

				timeline._linksDnD = linkDnD.createLinkDND();
				timeline._tasksDnD = taskDnD.createTaskDND();
				timeline._tasksDnD.extend(timeline);

				if(timeline.$config.id == "timeline") {
					this.extendGantt(timeline);
				}
			},
			onInitialized: function (timeline) {
				this._attachDomEvents(gantt);
				this._attachGanttEvents(gantt);
				this._attachStateProvider(gantt, timeline);

				timeline._tasksDnD.init(timeline, gantt);
				timeline._linksDnD.init(timeline, gantt);

				if(timeline.$config.id == "timeline"){
					this.extendDom(timeline);
				}

			},
			onDestroyed: function (timeline) {
				this._clearGanttEvents(gantt);
				this._clearDomEvents(gantt);
				this._clearStateProvider(gantt);
			},
			extendDom: function(timeline){
				gantt.$task = timeline.$task;
				gantt.$task_scale = timeline.$task_scale;
				gantt.$task_data = timeline.$task_data;
				gantt.$task_bg = timeline.$task_bg;
				gantt.$task_links = timeline.$task_links;
				gantt.$task_bars = timeline.$task_bars;
			},

			extendGantt: function(timeline){
				gantt.dateFromPos = gantt.bind(timeline.dateFromPos, timeline);
				gantt.posFromDate = gantt.bind(timeline.posFromDate, timeline);
				gantt.getRowTop = gantt.bind(timeline.getRowTop, timeline);
				gantt.getTaskTop = gantt.bind(timeline.getItemTop, timeline);
				gantt.getTaskPosition = gantt.bind(timeline.getItemPosition, timeline);
				gantt.getTaskHeight = gantt.bind(timeline.getItemHeight, timeline);
				gantt.columnIndexByDate = gantt.bind(timeline.columnIndexByDate, timeline);
				gantt.roundTaskDates = gantt.bind(timeline.roundTaskDates, timeline);
				gantt.getScale = gantt.bind(timeline.getScale, timeline);
				gantt.getTaskNode = function (id) {
					return timeline._taskRenderer.rendered[id];
				};
				gantt.getLinkNode = function (id) {
					return timeline._linkRenderer.rendered[id];
				};

			},

			_attachDomEvent: function (event, className, handler){
				if(!this._events){
					this._events = [];
				}
				var mouseEvents = services.getService("mouseEvents");
				var e = {event:event, className: className, handler:handler, root:this.$task};
				mouseEvents.delegate(e.event, e.className, e.handler, e.root);
				this._events.push(e);
			},

			_clearDomEvents: function(){
				var mouseEvents = services.getService("mouseEvents");
				for(var i = 0; i < this._events.length; i++){
					var e = this._events[i];
					mouseEvents.detach(e.event, e.className, e.handler, e.root);
				}
				this._events = [];
			},

			_attachDomEvents: function(gantt){
				function _delete_link_handler(id, e) {
					if (id && this.callEvent("onLinkDblClick", [id, e])) {

						var link = this.getLink(id);
						if (this.isReadonly(link)) return;

						var title = "";
						var question = this.locale.labels.link + " " + this.templates.link_description(this.getLink(id)) + " " + this.locale.labels.confirm_link_deleting;

						window.setTimeout(function () {
							gantt._dhtmlx_confirm(question, title, function () {
								gantt.deleteLink(id);
							});
						}, (this.config.touch ? 300 : 1));
					}
				}

				this._attachDomEvent("click", "gantt_task_link", gantt.bind(function (e, trg) {
					var id = this.locate(e, this.config.link_attribute);
					if (id) {
						this.callEvent("onLinkClick", [id, e]);
					}
				}, gantt));

				this._attachDomEvent("click", "gantt_scale_cell", gantt.bind(function (e, trg) {
					var pos = domHelpers.getRelativeEventPosition(e, gantt.$task_data);
					var date = gantt.dateFromPos(pos.x);
					var coll = Math.floor(gantt.columnIndexByDate(date));

					var coll_date = gantt.getScale().trace_x[coll];

					gantt.callEvent("onScaleClick", [e, coll_date]);
				}, gantt));

				this._attachDomEvent("doubleclick", "gantt_task_link", gantt.bind(function (e, id, trg) {
					var id = this.locate(e, gantt.config.link_attribute);
					_delete_link_handler.call(this, id, e);
				}, gantt));

				this._attachDomEvent("doubleclick", "gantt_link_point", gantt.bind(function (e, id, trg) {
					var id = this.locate(e),
						task = this.getTask(id);

					var link = null;
					if (trg.parentNode && domHelpers.getClassName(trg.parentNode)) {
						if (domHelpers.getClassName(trg.parentNode).indexOf("_left") > -1) {
							link = task.$target[0];
						} else {
							link = task.$source[0];
						}
					}
					if (link)
						_delete_link_handler.call(this, link, e);
					return false;
				}, gantt));
			},

			_attachGanttEvents: function(gantt){
				this._clearGanttEvents(gantt);

				function refreshId(renders, oldId, newId, item) {
					for (var i = 0; i < renders.length; i++) {
						renders[i].change_id(oldId, newId);
						renders[i].render_item(item);
					}
				}

				this._onTaskIdChange = gantt.attachEvent("onTaskIdChange", function (oldId, newId) {
					refreshId(gantt._getTaskLayers(), oldId, newId, gantt.getTask(newId));
				});

				if (this._onLinkIdChange)
					gantt.detachEvent(this._onLinkIdChange);

				this._onLinkIdChange = gantt.attachEvent("onLinkIdChange", function (oldId, newId) {
					refreshId(gantt._getLinkLayers(), oldId, newId, gantt.getLink(newId));
				});
			},

			_clearGanttEvents: function(gantt){
				if (this._onTaskIdChange)
					gantt.detachEvent(this._onTaskIdChange);
				if (this._onLinkIdChange)
					gantt.detachEvent(this._onLinkIdChange);
			},

			_attachStateProvider: function(gantt, timeline){
				var self = timeline;
				var state = services.getService("state");
				state.registerProvider("tasksTimeline", function(){
					return {
						scale_unit: self._tasks ? self._tasks.unit : undefined,
						scale_step:  self._tasks ? self._tasks.step  : undefined
					};
				});
			},

			_clearStateProvider: function(){
				var state = services.getService("state");
				state.unregisterProvider("tasksTimeline");
			}
		};
	};

})();

module.exports = initializer;


//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/timeline/main_timeline_initializer.js
// module id = 47
// module chunks = 0